import React from "react";
import { Button, Col, Row } from "react-bootstrap";

const HighCourts = () => {
  const handleClick = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior

    const userConfirmed = window.confirm(
      "You are being redirected to an external website. Please note that District Court Dehradun cannot be held responsible for external websites content & privacy policies."
    );

    if (userConfirmed) {
      window.open(e.currentTarget.href, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <section className="p-5 mx-md-5 text-center">
        <h1 className="text-center">High Court Links</h1>
        <div className="text-center justify-content-center mx-auto">
          <Row className="justify-content-center mt-5">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://www.allahabadhighcourt.in/"
                target="_blank"
              >
                Allahabad High Court
              </Button>
            </Col>
            <Col md={5} className="mt-sm-2 mt-md-0">
              <Button
                size="lg"
                className="w-100"
                href="http://hc.ap.nic.in"
                target="_blank"
              >
                Andhra Pradesh High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="https://tshc.gov.in/"
                target="_blank"
              >
                Telangana High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://bombayhighcourt.nic.in/"
                target="_blank"
              >
                Bombay High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="https://calcuttahighcourt.gov.in/"
                target="_blank"
              >
                Calcutta High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://highcourt.cg.gov.in/"
                target="_blank"
              >
                Chhattisgarh High Court
              </Button>
            </Col>
          </Row>

          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://delhihighcourt.nic.in/"
                target="_blank"
              >
                Delhi High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://ghconline.gov.in/"
                target="_blank"
              >
                Gauhati High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://gujarathighcourt.nic.in/"
                target="_blank"
              >
                Gujarat High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://hphighcourt.nic.in/"
                target="_blank"
              >
                Himachal Pradesh High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://jkhighcourt.nic.in/"
                target="_blank"
              >
                Jammu & Kashmir High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://jharkhandhighcourt.nic.in/"
                target="_blank"
              >
                Jharkhand High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://karnatakajudiciary.kar.nic.in/"
                target="_blank"
              >
                Karnataka High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://highcourtofkerala.nic.in/"
                target="_blank"
              >
                Kerala High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://mphc.gov.in/"
                target="_blank"
              >
                Madhya Pradesh High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://www.hcmadras.tn.nic.in/"
                target="_blank"
              >
                Madras High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://hcmimphal.nic.in/"
                target="_blank"
              >
                Manipur High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://meghalayahighcourt.nic.in/"
                target="_blank"
              >
                Meghalaya High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://www.orissahighcourt.nic.in/"
                target="_blank"
              >
                Orissa High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://patnahighcourt.gov.in/"
                target="_blank"
              >
                Patna High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://highcourtchd.gov.in/"
                target="_blank"
              >
                Punjab & Haryana High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://hcraj.nic.in/"
                target="_blank"
              >
                Rajasthan High Court
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://highcourtofsikkim.nic.in/"
                target="_blank"
              >
                Sikkim High Court
              </Button>
            </Col>
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://thc.nic.in/"
                target="_blank"
              >
                Tripura High Court
              </Button>
            </Col>
          </Row>

          <Row className="justify-content-center mt-2">
            <Col md={5}>
              <Button
                size="lg"
                className="w-100"
                href="http://highcourtofuttarakhand.gov.in/"
                target="_blank"
                onClick={handleClick}
                aria-label="Uttarakhand High Court - External site that opens in a new window"
                title="Uttarakhand High Court - External site that opens in a new window"
              >
                Uttarakhand High Court
              </Button>
            </Col>
            <Col md={5}></Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default HighCourts;
